import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import * as PIXI from "pixi.js";
import Facade from "@/Facade";
import Linear from "gsap";
import {calculateTimeToMakeBets} from "@/managers/comunication/socket/utils";
import Config from "@/config/Config";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";

export default class MakeBetsContainer extends BaseContainer {

  constructor(data) {
    super(data)

    this.init()
  }

  init(data) {
    Signals.forceRoundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)

    this.o = {t: 0}
    this.isStarted = false
    this.startPos = 0
    this.multiplierScale = 0.64

    this.createProgressLogo()
    this.createText()
    this.alpha = 0
  }

  createText() {
    if (this.makeBetsText && this.makeBetsText.parent === this) {
      this.removeChild(this.makeBetsText)
      this.makeBetsText = null
    }

    const text = Facade.textFactory.getLocalizedText('makeBets')
    const style = Facade.textFactory.getStyle('makebets')
    this.makeBetsText = new LocalizedPIXIText(text, style)

    this.addChild(this.makeBetsText)
    this.makeBetsText.pivot.set((this.makeBetsText.width / 2) + 14, this.makeBetsText.height / 2)
    this.makeBetsText.y -= 30
  }

  createProgressLogo() {
    this.bar = new PIXI.Sprite(PIXI.Texture.from('loading/bar'))
    this.fill = new PIXI.Sprite(PIXI.Texture.from('loading/fill'))

    this.fill.scale.set(0.5, 0.3)
    this.bar.scale.set(0.3)

    this.bar.anchor.set(0.5)
    this.fill.anchor.set(0.5)

    this.bar.position.set(-10, 24)
    this.fill.position.set(3, 26)

    this.progressMaskWidth = 1093 * this.multiplierScale
    this.progressMaskHeight = 208 * this.multiplierScale
    this.progressMask = new PIXI.Graphics()
    this.progressMask.x = this.bar.position.x
    this.progressMask.pivot.set(0, this.progressMaskHeight / 2)
    this.progressMask.position = this.bar.position
    this.progressMask.position.x -= this.progressMaskWidth / 2
    this.progressMask.beginFill(0xffffff)
    this.progressMask.drawRect(0, 0, this.progressMaskWidth, this.progressMaskHeight)
    this.progressMask.endFill()

    this.addChild(this.fill, this.bar)
    this.addChild(this.progressMask)

    this.fill.mask = this.progressMask
  }

  onProgress(percent) {
    this.progress = percent
  }

  set progress(value) {
    this.progressMask.scale.x = (value / 100)
  }

  onMakeBets() {
    // TODO: Rude fix. Actually it would be proper to ask backend to increase the makeBetsTime
    // But in this case, also I think that all the games have a little differences between that
    const progressCheatProgress = 3; // seconds, to keep progress bar longer
    this.createText()

    this.etalon = calculateTimeToMakeBets(Facade.model.totalTimeToMakeBets, Config.timeForExplosion)
    this.time = calculateTimeToMakeBets(Facade.model.makeBetsTime, Config.timeForExplosion)
    this.startPos = this.time < this.etalon ? 100 - ((this.time / this.etalon) * 100) : 0
    this.onProgress(this.startPos)
    TweenMax.to(this, .2, {alpha: 1})

    this.o.t = this.startPos
    TweenMax.to(this.o, this.time + progressCheatProgress, {
      t: 100, ease: Linear.easeNone, onUpdate: () => {
        this.onProgress(this.o.t)
        if (this.o.t > 99 && !this.isStarted) {
          this.isStarted = true
          Signals.startPlane.dispatch()
        }
      }
    })
  }

  onRoundStart() {
    this.createText()
    TweenMax.to(this, .2, {alpha: 0})
  }

  onRoundEnd() {
    this.createText()
    this.isStarted = false
  }

}

